<template>
  <div class="main">
    <div v-if="NotAllowed" class="error-message">
      <figure class="figure-error">
        <img src="../../../assets/images/round.png" />
      </figure>
      <p>⚠️ {{ NotAllowed }}</p>
    </div>

    <div class="isLogin" v-if="!NotAllowed && !isLogin">
      <figure class="figure-error">
        <img src="../../../assets/images/round.png" />
      </figure>
      <p>
        <span class="boldText"> بندیتویی عزیز </span> 😊 برای بازی گردونه شانس
        لطفا <span class="boldText"> وارد پنل کاربری </span> بشید تا
        <span class="boldText"> جایزه‌ </span> هاتون ثبت بشه 🎁
      </p>
    </div>

    <div class="costGame" v-if="costGame">
      <div v-if="costGame.bon_count == 0 && costGame.score_count == 0">
        بازی
        <span class="boldText"> رایگانه </span> 🎉 شانس خودتو امتحان کن!
      </div>
      <div v-else>
        <span class="boldText"> بندیتویی عزیز </span>
        برای شروع این بازی گردونه شانس، لازمه که
        <span class="boldText" v-if="costGame.bon_count > 0">
          {{ costGame.bon_count }} بن کارت
        </span>
        <span v-if="costGame.bon_count > 0 && costGame.score_count > 0">
          و
        </span>
        <span class="boldText" v-if="costGame.score_count > 0">
          {{ costGame.score_count }} امتیاز
        </span>
        خرج کنی. آماده‌ای؟ 🎡
      </div>
    </div>

    <FortuneWheel
      ref="child"
      @onCanvas="onCanvasRotateStart"
      v-if="hasSpin && !NotAllowed && isLogin && prizes.length"
      :prizes="prizes"
      :prizeId="prizeid"
    />
    <div v-else-if="!hasSpin">
      <span> ⚠️ کاربر گرامی، گردونه شانس غیر فعال است </span>
    </div>
  </div>
</template>

<script>
import FortuneWheel from "../components/wheelOfFortune/index.vue";

import axios from "axios";

export default {
  components: {
    FortuneWheel,
  },
  data() {
    return {
      cavansVerify: true,
      canvasOptions: {
        radius: 670,
        textRadius: 200,
        textLength: 30,
        textDirection: "vertical",
        lineHeight: 40,
        borderWidth: 10,
        borderColor: "#ccc",
        btnText: "بزن",
        btnWidth: 70,
        fontSize: 50,
      },
      prizeid: "",
      flagSpin: false,
    };
  },
  computed: {
    prizes() {
      const allSpinRewards = this.$store.getters["front/getAllSpinRewards"];
      let result = [];
      console.log(allSpinRewards, "this is allSpinRewards :");
      if (!allSpinRewards) return [];
      result = allSpinRewards.map((reward, index) => ({
        id: reward.id,
        name: this.getRewardName(reward),
        value: reward.reward_value,
        bgColor: index % 2 === 0 ? "#faabcf" : "#E2689F",
        //  bgColor: this.getRewardColor(reward.reward_type),
        color: index % 2 === 0 ? "#000" : "#fff",
        location: this.location(index),
      }));
      console.log(result, "result");
      return result;
    },

    hasSpin() {
      const homeData = this.$store.getters["front/getHomeData"];
      let hasSpin = false;
      if (homeData && homeData.active_games) {
        hasSpin = homeData.active_games.find((o) => o.title === "spin");
      }
      console.log(hasSpin, "this is hasSpin :");
      return hasSpin;
    },
    costGame() {
      return this.$store.getters["front/getGamePrice"];
    },
    isLogin() {
      return this.$store.getters["front/getLoginStatus"];
    },
    NotAllowed() {
      return this.$store.getters["front/getErrorNotAllowed"];
    },
  },
  methods: {
    //  getRewardColor(type) {
    //    const colors = {
    //      gift_wallet: "#faabcf",
    //      coupon_flat: "#fdf688",
    //      coupon_percentage: "#faabcf",
    //      nothing: "#fdf688",
    //    };
    //    return colors[type] || "#ffffff";
    //  },
    //  spinExternalWheel() {
    //    this.$refs.FortuneWheel.spinWheel();
    //  },
    location(index) {
      return { startLo: index, endLo: index + 1 };
    },
    getRewardName(reward) {
      switch (reward.reward_type) {
        case "gift_wallet":
          return `کیف پول  ${Number(reward.reward_value).toLocaleString(
            "en-US"
          )} تومان`;
        case "coupon_flat":
          return `کد تخفیف ${Number(reward.reward_value).toLocaleString(
            "en-US"
          )} تومان`;
        case "coupon_percentage":
          return `کد تخفیف ${reward.reward_value} درصد`;
        case "nothing":
          return "پوچ";
        case "score":
          return ` ${reward.reward_value} امتیاز`;
        case "bon":
          return ` ${reward.reward_value} بن`;
        default:
          return "نامشخص";
      }
    },

    async onCanvasRotateStart() {
      try {
        const response = await axios.post("/customer/games/spin");
        console.log(response, "response");

        if (!response.data.success) {
          alert(
            response.data.message || "خطایی رخ داده است، لطفا دوباره تلاش کنید."
          );
          return;
        }

        const reward =
          response.data.data.gamificationResponse.gameRewardObjects;

        let winningPrize = reward[0].id;
        let alertName = this.getRewardName(reward[0])
        this.$refs.child.spinWheel(winningPrize);
        if (alertName === "پوچ") {
          window.swal({
            title: "😞 متأسفیم!",
            text: "متأسفانه این بار چیزی برنده نشدی، اما شانست رو دوباره امتحان کن! 🎡",
            icon: "warning",
            confirmButtonText: "باشه، دوباره امتحان می‌کنم!",
            confirmButtonColor: "#f39c12",
            backdrop: true,
          });
        } else {
          window.swal({
            title: "🎉 تبریک! 🎉",
            text: `شما برنده ${alertName} شدید! 🎁`,
            icon: "success",
            confirmButtonText: "فوق‌العاده‌ست!",
            confirmButtonColor: "#faabcf",
            backdrop: true,
          });
        }
      } catch (error) {
        console.error(error);
        alert(
          error.response?.data?.message || "خطای غیرمنتظره‌ای رخ داده است."
        );
      }
    },
  },
  mounted() {
    console.log(this.isLogin);
    if (this.isLogin) {
      this.$store.dispatch("front/createSpinGame");
    }
  },
  watch: {
    isLogin(newValue, oldValue) {
      if (newValue !== oldValue && newValue == true) {
        this.$store.dispatch("front/createSpinGame");
      }
    },
  },
};
</script>
<style scoped>
.main {
  width: 80%;
  margin: 30px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.boldText {
  color: #ff6bb5;
  font-weight: 800;
}

.error-message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: red;
  font-size: 20px;
  font-weight: 700;
}
.figure-error {
  width: 25%;
}
.figure-error img {
  width: 100%;
}

.isLogin {
  display: flex;
  flex-direction: column;
  width: 80%;
  margin: 30px auto;
  justify-content: center;
  align-items: center;
  font-weight: 800;
}

.startBtn {
  padding: 10px 30px;
  border-radius: 15px;
  background: rgb(255, 193, 224);
  background: linear-gradient(
    332deg,
    rgba(255, 193, 224, 1) 0%,
    rgba(197, 29, 106, 1) 22%,
    rgba(200, 36, 111, 1) 28%,
    rgba(255, 193, 224, 1) 95%
  );
  color: #fff;
}

/* .startBtn:hover {
  background: rgb(255, 193, 224);
  background: linear-gradient(
    332deg,
    rgba(255, 193, 224, 1) 0%,
    rgba(197, 29, 106, 1) 72%,
    rgba(200, 36, 111, 1) 79%,
    rgba(255, 193, 224, 1) 100%
  );
} */

.costGame {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}
</style>
<style>
canvas * {
  font-family: "iran-sans" !important;
}
.fw-btn__btn {
  background: rgb(255, 193, 224) !important;
  background: radial-gradient(
    circle,
    rgba(255, 193, 224, 1) 0%,
    #c51d6a 100%
  ) !important;
  cursor: pointer !important;
  color: #000000 !important;
  font-size: 18px !important;
  box-shadow: 3px 6px 23px 0px rgba(0, 0, 0, 0.295) !important;
  border: 6px solid #ccc !important;
}
.fw-btn__btn:hover {
  box-shadow: 3px 6px 23px 0px rgba(0, 0, 0, 0.507) !important;
}

.fw-btn__btn:before {
  border-left: 8px solid transparent !important;
  border-right: 8px solid transparent !important;
  border-bottom: 13px solid #db5b97 !important;
  transform: translate(-50%) translateY(2px) !important;
  z-index: 10;
}
.fw-btn__btn::after {
  border-left: 14px solid transparent !important;
  border-right: 14px solid transparent !important;
  border-bottom: 25px solid #ccc !important;
  transform: translateX(-50%) !important;
}
</style>
